export const  TiposDomicilioEnum  = Object.freeze({
    POSTAL: 1,
    FISCAL: 2,
    ENVIO: 3,
    COMERCIAL: 3,
})